import type { SpendCategoryGlCodeDto } from 'entities/ReportSpendSummary';

export function visibleGlCodes(
    codes: SpendCategoryGlCodeDto[] | undefined,
): SpendCategoryGlCodeDto[] {
    return (codes ?? []).filter((code) => code.glCode.trim());
}

export function uniqueGlCodeValues(codes: Array<{ glCode: string }>): string[] {
    const seen = new Set<string>();

    return codes
        .flatMap((code) => {
            const value = code.glCode.trim();
            if (!value || seen.has(value)) {
                return [];
            }
            seen.add(value);
            return [value];
        })
        .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
}

export function formatGlCodeLabel(
    codes: SpendCategoryGlCodeDto[],
    formatCount: (count: number) => string,
): string {
    const unique = uniqueGlCodeValues(codes);
    if (unique.length === 0) {
        return '-';
    }
    if (unique.length === 1) {
        return unique[0];
    }
    return formatCount(unique.length);
}
